import { Space, Table, Tooltip } from 'antd';
import 'antd/dist/antd.css';
import React from 'react';
import '../../css/ant.css';
import TableFilter from './TableFilter';
import TheCSVButton from './TheCSVButton';
import { CheckOutlined, DeleteOutlined, EditOutlined, RollbackOutlined, InfoCircleOutlined, MailOutlined }  from '@ant-design/icons';
import { SendFileByEmail } from '../../networking/NetworkingEmails';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

export default class NewDynamicTable extends React.Component {
    
    state = {
        data            : this.props.data,
        listToShow      : [],
        filterScreen    : false,
        loading         : false,
        filtering       : false,
        filters         : {},
        pageNumber      : this.props.pageNumber,
        isAllChecked    : false,
        emailToSend     : '',
        showModalDialog : false,
        disabledButtonSend    : true,
    }

    componentDidMount = () => {
        let dataHelper = this.props.data
        if (this.props.formats !== undefined) {
            debugger
            dataHelper.forEach((element) => {
                this.props.formats.forEach((values) => {
                    if (element[values.header] != null) {
                        if(element[values.formatCurrencyRate] != null)
                        {
                            element[values.header] = values.formatFunction(element[values.header], element[values.formatCurrency[0]],element[values.formatCurrency[1]]);
                        }else if(element[values.formatCurrency] != null)
                        {
                            element[values.header] = values.formatFunction(element[values.header], element[values.formatCurrency]);
                        }
                        else
                        {
                            if(values.formatCurrency != null)
                            {
                                element[values.header] = values.formatFunction(element[values.header], values.formatCurrency);
                            }
                            else
                            {
                                if(element[values.formatBuyCurrency] != null && element[values.formatSellCurrency]  != null)
                                    {
                                        element[values.header] = values.formatFunction(element[values.header], element[values.formatBuyCurrency] , element[values.formatSellCurrency] );
                                    }
                                    else
                                    {
                                        element[values.header] = values.formatFunction(element[values.header]);
                                    }
                            }
                        }
                        console.log(element)
                        //element[values.header] = element[values.formatFunction](element[values.header]);
                        
                    }
                })
            })
        }
        this.setState({ data: dataHelper });
    }

    componentDidUpdate = (prevProps) => {
        if(prevProps.data !== this.props.data){
            let dataHelper = this.props.data
            //debugger;
            if (this.props.formats !== undefined) {
                dataHelper.forEach((element) => {
                    this.props.formats.forEach((values) => {
                        if (element[values.header] != null) {
                            //debugger;
                            if(element[values.formatCurrency] != null)
                            {
                                element[values.header] = values.formatFunction(element[values.header], element[values.formatCurrency]);
                            }
                            else
                            {
                                if(values.formatCurrency != null)
                                {
                                    element[values.header] = values.formatFunction(element[values.header], values.formatCurrency);
                                }
                                else
                                {
                                    if(element[values.formatBuyCurrency] != null && element[values.formatSellCurrency]  != null)
                                    {
                                        element[values.header] = values.formatFunction(element[values.header], element[values.formatBuyCurrency] , element[values.formatSellCurrency] );
                                    }
                                    else
                                    {
                                        element[values.header] = values.formatFunction(element[values.header]);
                                    }
                                }
                            }
                        }
                    })
                })
            }
            this.setState({ data: dataHelper });
        }
    }
    
    getFilterHeaders = () => {
        var hiddenHeaders = [];
        var columns = [];
        if(this.props.data != null && this.props.data.length > 0) {
            var testObj = this.props.data[0];
            var headers = Object.keys(testObj);
            if(this.props.hiddenHeaders !== undefined){
                hiddenHeaders = this.props.hiddenHeaders;
            }

            headers.forEach((value) => {
                
                    var includesHiddenDollar = value.includes('$');
                    if (value !== 'TotalCount')
                    {
                        if (!includesHiddenDollar)
                        {
                            var isHidden = false;
                            for (let i = 0; i < hiddenHeaders.length; i++) {
                                if(value === hiddenHeaders[i])
                                {
                                    isHidden = true;
                                    break;
                                }
                            }

                            if (!isHidden){
                                columns.push(value);
                            }
                        }
                    }
            })
        }

        return columns;
    }
 
    getColumns = () => {
        var hiddenHeaders = [];
        var columns = [];
        if(this.props.data != null && this.props.data.length > 0) {
            var testObj = this.props.data[0];
            var headers = Object.keys(testObj);
            if(this.props.hiddenHeaders !== undefined){
                hiddenHeaders = this.props.hiddenHeaders;
            }
            let clickFunctionHeader = '';
            if(this.props.clickFunctionHeader !== undefined){
                clickFunctionHeader = this.props.clickFunctionHeader;
            }

            headers.forEach((value) => {
                
                    var includesHiddenDollar = value.includes('$');
                    if (value !== 'TotalCount')
                    {
                        if (!includesHiddenDollar)
                        {
                            var isHidden = false;
                            for (let i = 0; i < hiddenHeaders.length; i++) {
                                if(value === hiddenHeaders[i])
                                {
                                    isHidden = true;
                                    break;
                                }
                            }

                            if (!isHidden){
                                if (value !== 'lookupdetails') {
                                    if(value === clickFunctionHeader && this.props.clickFunction)
                                    {
                                        columns.push({
                                            title: value,
                                            dataIndex: value,
                                            key: value,
                                            sorter: (a, b) => { 
                                                let aValue = a[value];
                                                let bValue = b[value];
                                                if(!aValue){
                                                    aValue='';
                                                }
                                                if(!bValue){
                                                    bValue='';
                                                }
                                                if(typeof aValue === 'number'){
                                                    return aValue - bValue;
                                                }
        
                                                return aValue.toString().localeCompare(bValue.toString());
                                            },
                                            sortDirections: ['descend', 'ascend'],
                                            align: this.props.align == null ? 'left' : this.props.align,
                                            render:(_,record) => {
                                                return <a
                                                onClick = {() => {this.props.clickFunction(record)}}
                                                style   = {{cursor:'pointer'}}
                                              >{record[value]}
                                              </a>
                                            }
                                        });
                                    }
                                    else
                                    {
                                        columns.push({
                                            title: value,
                                            dataIndex: value,
                                            key: value,
                                            sorter: (a, b) => { 
                                                let aValue = a[value];
                                                let bValue = b[value];
                                                if(!aValue){
                                                    aValue='';
                                                }
                                                if(!bValue){
                                                    bValue='';
                                                }
                                                if(typeof aValue === 'number'){
                                                    return aValue - bValue;
                                                }
        
                                                return aValue.toString().localeCompare(bValue.toString());
                                            },
                                            sortDirections: ['descend', 'ascend'],
                                            align: this.props.align == null ? 'left' : this.props.align
                                        });
                                    }
                                } else {
                                    columns.push({
                                        title: value,
                                        dataIndex: value,
                                        key: value,
                                        sorter: (a, b) => { 
                                            let aValue = a[value];
                                            let bValue = b[value];
                                            if(!aValue){
                                                aValue='';
                                            }
                                            if(!bValue){
                                                bValue='';
                                            }
                                            if(typeof aValue === 'number'){
                                                return aValue - bValue;
                                            }
    
                                            return aValue.toString().localeCompare(bValue.toString());
                                        },
                                        sortDirections: ['descend', 'ascend'],
                                        render: (text,record) => {
                                            let helper = [];
                                            if (Array.isArray(record.lookupdetails)) {
                                                //debugger
                                                record.lookupdetails.forEach((el) => {
                                                    helper.push(el.Description);
                                                });
                                            }
                                            return helper.join();
                                        }
                                    });
                                }
                                
                                
                            }
                        }
                    }
            })

            if(this.props.dynamicActions !== undefined || this.props.useDeleteButton){
                let links = [];
                //{ name: 'View', function: this.handleSearchClick, isIcon: true, icon:'fa fa-search' }
                columns.push({
                    title: 'Actions',
                    key: 'actions',
                    render: (text, record) => {
                        let links = [];
                        if(this.props.dynamicActions){
                            this.props.dynamicActions.forEach((dynAction) => {                                
                                if (dynAction.isIcon != null && dynAction.isIcon && dynAction.icon != null && dynAction.icon !== '') {
                                    if(this.props.useIcons != null && this.props.useIcons){
                                        if(dynAction.getIcon)
                                        {
                                            links.push(<Tooltip title={dynAction.name}><a style={{cursor: 'pointer'}} onClick={(event) => {event.stopPropagation(); dynAction.function(record);}}>{dynAction.getIcon(record)}</a></Tooltip>);
                                        }
                                        else
                                        {
                                        links.push(<Tooltip title={dynAction.name}><a style={{cursor: 'pointer'}} onClick={(event) => {event.stopPropagation(); dynAction.function(record);}}>{dynAction.icon}</a></Tooltip>);
                                        }

                                    }else{
                                        links.push(<a className={dynAction.icon} title={dynAction.name} style={{ cursor: 'pointer' }} onClick={(event) => { event.stopPropagation(); dynAction.function(record) }} />);
                                    }                                    
                                }
                                else {
                                    links.push(<a style={{ cursor: 'pointer' }} onClick={(event) => { event.stopPropagation(); dynAction.function(record) }}>{dynAction.name}</a>);
                                }
                            });
                        }
                        if(this.props.useDeleteButton){
                            if(this.props.useIcons){
                                    links.push(<Tooltip title="Delete"><a style={{cursor: 'pointer'}} onClick={(event) => {event.stopPropagation(); this.handleDeleteClick(record);}}><DeleteOutlined /></a></Tooltip>);
                            }
                            else{
                                links.push(<a style={{cursor: 'pointer'}} onClick={(event) => {event.stopPropagation(); this.handleDeleteClick(record);}}>Delete</a>);
                            }                            
                        }
                        return (
                            <Space size="middle">
                                {links}
                            </Space>
                        );
                    },
                });
            }
        }

        return columns;
    }

    handleDeleteClick = (obj) => {
        if (!JSON.parse(localStorage.getItem('HasComplianceAccess'))) {
            this.props.deleteFunction(obj);
        }
    }

    onFilterButtonClick = () =>{
        this.setState({filterScreen: true});
    }

    clearFilterButtonClick = () => {
        this.setState({filtering: false, filters: {}, data: this.props.data, numberOfPages: this.props.numberOfPages});
    }

    onCloseFilterScreen = () => {
        this.setState({filterScreen: false});
    }

    runFilter = (filters) => {
        var newData = [];
        this.setState({filterScreen: false, loading: true, filtering: true, filters: filters});
        this.props.filterFunction().then((rows) => {
            rows.forEach(element => {
                var isOkay = true;
                for(var i = 0; i < filters.length; i++){
                    if(filters[i].value !== '' && element[filters[i].header] !== undefined){
                        if(String(element[filters[i].header]).toLowerCase().includes(String(filters[i].value).toLowerCase()) && isOkay){
                            isOkay = true;
                        } else {
                            isOkay = false;
                        }
                    }
                }
                if(isOkay){
                    newData.push(element);
                }
            });
            this.setState({data: newData, loading: false, numberOfPages: Math.ceil(newData.length/this.props.numberPerPage), });
        });
    }
    
    closeModal = () => {
        this.setState({
            showModalDialog: false,
        })
    } 
    
    handleUpdateEmailToSend(event) {
        this.setState({ emailToSend: event.target.value },
            () => {
                if (this.validateEmail(this.state.emailToSend)) {
                    this.isEmailValid(true);
                } else {
                    this.isEmailValid(false);
                }
            });
    }

    validateEmail = (email) => {
        const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
        if (email != null && email != '') {
            if (email.includes(';')) {
                const emails = email.split(';');
                if (emails.some(e => !e.match(regex))) {
                    return false;
                }
            } else {
                if (!email.match(regex)) {
                    return false;
                }
            }
        }
        else
        {
            return false;
        }
        return true;
    }

    isEmailValid(validator) {
        if (validator) {
            this.setState({ disabledButtonSend: false });
        } else {
            this.setState({ disabledButtonSend: true });
        }
    }    
    
    handleSendEmailClick(event) {
        event.preventDefault();
        let today = new Date();
        let yearString = today.getFullYear().toString();
        let monthString = (today.getMonth()+1).toString().padStart(2, '0');
        let dayString = today.getDate().toString().padStart(2, '0');
        let hourString = today.getHours().toString().padStart(2, '0');
        let minuteString = today.getMinutes().toString().padStart(2, '0');
        let timeStamp = yearString + monthString + dayString + hourString + minuteString;

        let email=this.state.emailToSend;
        let data=this.state.data;
        let nameFile=this.props.tableName + timeStamp + '.csv';
        if(email!=''){
            this.SendFileByEmail(email, nameFile, data);
        }        
    }

    SendFileByEmail = (email,nameFile,data) =>{
        let data_csv = this.convertToCSV(data);        
        const base64 = btoa(unescape(encodeURIComponent(data_csv)));
        let model = {
            email: email,
            fileName: nameFile,
            data: base64
        }
        SendFileByEmail(model);
        this.setState({ showModalDialog: false});
    }

    convertToCSV = (data) => {
        if (data.length === 0) return ""
    
        // Obtener las cabeceras
        const headers = Object.keys(data[0]).join(",")
    
        // Convertir cada fila a CSV
        const rows = data.map((item) =>
          Object.values(item)
            .map((value) =>
              // Escapar comillas y envolver en comillas si contiene comas
              typeof value === "string" && (value.includes(",") || value.includes('"'))
                ? `"${value.replace(/"/g, '""')}"`
                : value,
            )
            .join(","),
        )
    
        return [headers, ...rows].join("\n")
    }

    OpenModalSendEmail(event){
        this.setState({ showModalDialog: true, });
    }

    render = () => {
        var showFilter = false;
        var showExport = false;
        var filterButton = [];
        var filterHeaders = [];
        var scrollStyle = {overflow: 'auto'};

        var id = "";
        
        if(this.props.id !== undefined){
            id = "-" + this.props.id;
        }

        if(this.props.useExportButton !== undefined){
            showExport = this.props.useExportButton;
        }

        if(this.props.useFilter !== undefined){
            showFilter = this.props.useFilter;
        }
        
        let dataSource = this.state.data;
        
        let columns = this.getColumns();
        filterHeaders = this.getFilterHeaders();

        if(showFilter)
        {
            if (!this.state.filtering) {
                filterButton.push(<i className="fa fa-fw fa-filter uk-align-right" key={"filter-icon" + id} onClick={this.onFilterButtonClick} style={{ fontSize: '1.50em', verticalAlign: 'middle', cursor: 'pointer', marginBottom: '2px', marginLeft: '10px' }} />);
            } else {
                filterButton.push(<i className="fa fa-fw fa-ban uk-align-right" key={"filter-icon" + id} onClick={this.clearFilterButtonClick} style={{ fontSize: '1.50em', verticalAlign: 'middle', cursor: 'pointer', marginBottom: '2px', marginLeft: '10px' }} />);
            }
        } else 
        {
            scrollStyle = {};
        }

        if(showExport){
            filterButton.push(<TheCSVButton board={this.props.tableName} data={this.state.data} useIcon={true}/>);
        }

        let rowSelection = null;

        if(this.props.useSelection) {
            rowSelection = {
                type: 'checkbox',
                onChange: this.props.onChangeSelection           
            };
    }

        return (
            <div style={scrollStyle}>
                
                <div className="uk-overflow-auto">
                    {filterButton}
                    {this.props.sendEmail && 
                    <div>
                        <MailOutlined style={{ 
                                width: '30px',
                                color: '#666',
                                marginLeft: '0px',
                                border:"0px solid #a511c0",
                                display:"inline-block",
                                backgroundColor: "white",
                                fontSize: '1.50em', verticalAlign: 'middle', cursor: 'pointer', marginBottom: '4px'
                                }} 
                                className="fa fa-fw uk-align-right"
                                onClick={this.OpenModalSendEmail.bind(this)}></MailOutlined>                            
                        <Dialog
                            open={this.state.showModalDialog}
                            onClose={this.closeModal}
                            fullWidth={true}
                            maxWidth='md'>
                            <DialogTitle id="id-dialog-sendemail" onClose={this.closeModal}>Send Email</DialogTitle>
                            <DialogContent dividers>
                                <form className="uk-form-stacked uk-grid">
                                    <div className="uk-width-2-2">
                                        <label className="uk-form-label" >Email:</label>
                                        <div className="uk-form-controls">
                                            <input className="uk-input" type="text" onChange={this.handleUpdateEmailToSend.bind(this)} value={this.state.emailToSend} />
                                        </div>
                                    </div>                            
                                    <div className="uk-width-1-1 uk-margin"> 
                                    <button className="uk-button uk-button-green" disabled={this.state.disabledButtonSend} onClick={this.handleSendEmailClick.bind(this)}>Send</button>
                                    </div>
                                </form>
                            </DialogContent>
                        </Dialog>
                    </div>}
                </div>
                
                <Table 
                    key = {(this.props.id) ? this.props.id : 'table'}
                    rowKey = {(record, rowIndex) => {
                        if(this.props.useSelection){
                            return record[this.props.selectionID];                        
                        }
                        else
                        {
                            return rowIndex;
                        }
                    }
                    }
                    className="uk-table-hover"
                    dataSource  = {[...dataSource]} 
                    rowSelection={rowSelection}
                    columns     = {columns} 
                    onRow       = {(record, rowIndex) => {
                        return {
                            onClick: event => {
                                if(this.props.clickFunction)
                                {
                                    this.props.clickFunction(record);
                                }
                            }
                        };
                    }}
                    size        = 'small'
                    scroll      = {{x: true}}
                />
                <TableFilter 
                    open={this.state.filterScreen}
                    onClose={this.onCloseFilterScreen}
                    headers={filterHeaders}
                    runFilter={this.runFilter}
                />
            </div>
        );
    }
}